import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const AudioContainer = styled.div`
  width: ${props => props.width || '100%'};
  max-width: ${props => props.maxWidth || '600px'};
  margin: ${props => props.margin || '0 auto'};
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius, 16px);
  padding: 15px;
  backdrop-filter: blur(var(--glass-blur, 10px));
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const AudioTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
`;

const StyledAudio = styled.audio`
  width: 100%;
  border-radius: 8px;
  outline: none;
  
  &::-webkit-media-controls-panel {
    background: var(--glass-2);
  }
  &::-webkit-media-controls-play-button,
  &::-webkit-media-controls-mute-button {
    background-color: var(--glass-3);
    border-radius: 50%;
  }
  &::-webkit-media-controls-current-time-display,
  &::-webkit-media-controls-time-remaining-display {
    color: var(--text-primary);
  }
`;

const AudioPlayerWidget = ({ node, isLiveMode }) => {
  const audioUrl = node.content?.audioUrl || '';
  const title = node.content?.title || 'Audio Titel';
  
  const width = node.style?.desktop?.width || '100%';
  const align = node.style?.desktop?.align || 'center';
  
  const justifyContent = align === 'left' ? 'flex-start' : (align === 'right' ? 'flex-end' : 'center');

  return (
    <div style={{ display: 'flex', justifyContent, width: '100%' }}>
      <AudioContainer width={width}>
        {title && <AudioTitle>{title}</AudioTitle>}
        {audioUrl ? (
          <StyledAudio controls src={audioUrl}>
            Your browser does not support the audio element.
          </StyledAudio>
        ) : (
          <div style={{ padding: '10px', textAlign: 'center', color: 'var(--text-muted)', border: '1px dashed var(--glass-border)' }}>
            Bitte trage eine Audio-URL (mp3/wav) ein.
          </div>
        )}
      </AudioContainer>
    </div>
  );
};

registry.register('audio_player', {
  label: 'Audio Player',
  icon: '🎵',
  category: 'media',
  defaultContent: {
    title: 'Podcast Episode 1',
    audioUrl: ''
  },
  defaultStyle: {
    desktop: {
      width: '100%',
      align: 'center'
    }
  },
  render: AudioPlayerWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Audio Einstellungen',
          fields: [
            { name: 'content.title', label: 'Titelanzeige', type: 'text' },
            { name: 'content.audioUrl', label: 'Audio URL (.mp3/.wav)', type: 'text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.width', label: 'Player Breite (z.B. 400px, 100%)', type: 'text' },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'left'}, {label:'Zentriert', value:'center'}, {label:'Rechts', value:'right'}] }
          ]
        }
      ]
    }
  ]
});
